(function () {
    'use strict';

    angular.module("imApp").factory("webpageSettingService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1226,
                    parameters: parms || {}
                });
            },
            listWebpageSettings: function (parms) {
                return $ihttp.post({
                    method: 9,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
